import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import DropDown from '../DropDown';
import DownloadAs from '../DownloadAs';
import { DROPDOWN_VARIANTS } from '../constants';
import classNames from 'classnames';
import { noop } from '../propTypes';

const ContentCard = (
    {
        id,
        heading,
        subHeading,
        showDropDown,
        showSecondDd,
        content,
        footer,
        dropDownLabel,
        dropDownLabel2,
        dropDownData,
        dropDownData2,
        dropDownOnClick,
        dropDownOnClick2,
        dropDownVariant,
        checkboxName,
        permissions,
        className,
        //loadingSecondDd,
        downloadable,
        onDownloadClick,
    },
    ref,
) => {
    return (
        <div ref={ref} className={classNames('content-box', className)}>
            <div className="card-header">
                <div className="row">
                    <div className="col">
                        <div className="heading">
                            {typeof heading == 'object' ? (
                                heading
                            ) : (
                                <h2 className="title">{heading}</h2>
                            )}
                            {downloadable ? (
                                <DownloadAs
                                    id={id}
                                    onDownloadClick={onDownloadClick}
                                />
                            ) : null}
                        </div>
                        <p className="desc">{subHeading}</p>
                    </div>
                    {showSecondDd ? (
                        <div className="col-4">
                            <DropDown
                                label={dropDownLabel2}
                                menuData={dropDownData2}
                                onChange={dropDownOnClick2}
                                variant={dropDownVariant}
                                checkboxName={checkboxName}
                                multiple={
                                    dropDownVariant ===
                                    DROPDOWN_VARIANTS.CHECKBOX
                                }
                                permissions={permissions}
                            />
                        </div>
                    ) : null}
                    {showDropDown ? (
                        <div className="col-4">
                            <DropDown
                                label={dropDownLabel}
                                menuData={dropDownData}
                                onChange={dropDownOnClick}
                                variant={dropDownVariant}
                                checkboxName={checkboxName}
                                multiple={
                                    dropDownVariant ===
                                    DROPDOWN_VARIANTS.CHECKBOX
                                }
                                permissions={permissions}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
            {content}
            {footer}
        </div>
    );
};

ContentCard.propTypes = {
    id: PropTypes.string,
    // To display the heading in the card
    heading: PropTypes.string,

    // To display the sub heading in the card
    subHeading: PropTypes.string,

    // Boolean to control if the drop down should be displayed or not
    showDropDown: PropTypes.bool,

    showSecondDd: PropTypes.bool,
    // The content to be rendered in the body of the card
    content: PropTypes.any,

    footer: PropTypes.any,
    // Label for the drop down
    dropDownLabel: PropTypes.string,

    dropDownLabel2: PropTypes.string,

    // obj to generate the menu items of the drop down
    dropDownData: PropTypes.array,
    dropDownData2: PropTypes.array,
    // To invoke a function on the press or click of a menu item of the drop down
    dropDownOnClick: PropTypes.func,
    dropDownOnClick2: PropTypes.func,
    // To select between the variants of drop down for e.g checkbox variant or list variant
    dropDownVariant: PropTypes.string,

    checkboxName: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    downloadable: PropTypes.bool,
    onDownloadClick: PropTypes.func,
    loadingSecondDd: PropTypes.bool,
};

ContentCard.defaultProps = {
    id: '',
    heading: null,
    subHeading: null,
    showDropDown: false,
    showSecondDd: false,
    content: null,
    footer: null,
    checkboxName: null,
    permissions: [],
    className: '',
    downloadable: false,
    onDownloadClick: noop,
    loadingSecondDd: false,
};

export default React.forwardRef(ContentCard);
